// Lib Imports
import React from 'react';
import { Anchor, Box, TextInput, Button, Text } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

// CORE Imports
import FormField from 'granite-admin/core/components/FormField';
import PhoneInput from 'granite-admin/core/components/PhoneInput/v2';
import Select from 'granite-admin/core/components/Select';
const primaryContact = process.env.REACT_APP_PRIMARY_CONTACT || 'EMAIL';
const allowAltRecovery = process.env.REACT_APP_ALLOW_ALTERNATE_RECOVERY || 'false';
const RequestTokenForm = ({
  onSubmit,
  query,
  organisation,
  setOrganisation
}) => {
  const validationSchema = Yup.object().shape({
    ...(organisation?.length && {
      organisation_id: Yup.number().required('Organization is required')
    }),
    phone: Yup.object().when('email', {
      is: email => !email || email.length === 0,
      then: Yup.object().shape({
        number: Yup.string().required('Phone is required').min(10, 'Too short').max(17, 'Too long')
      })
    }),
    email: Yup.string().when('phone', {
      is: phone => !phone?.number || phone?.number.length === 0,
      then: Yup.string().required('Email is required').min(2, 'Too Short!').max(50, 'Too Long!').email('Invalid email')
    })
  }, [['email', 'phone']]);
  const {
    email = ''
  } = query ?? {};
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      email,
      organisation_id: ''
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  }) => /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, errors.title), primaryContact === 'EMAIL' && allowAltRecovery === 'false' ? /*#__PURE__*/React.createElement(FormField, {
    name: "email",
    label: "Email",
    required: true,
    error: touched.email && errors.email
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "email",
    name: "email",
    placeholder: "john.doe@gmail.com",
    onChange: e => {
      handleChange(e);
      setOrganisation([]);
      setFieldValue('organisation_id', '');
    },
    onBlur: handleBlur,
    value: values.email
  })) : (primaryContact === 'EMAIL' || primaryContact === 'PHONE') && allowAltRecovery === 'true' ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FormField, {
    name: "email",
    label: "Email address",
    required: true,
    error: touched.email && errors.email
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "email",
    name: "email",
    placeholder: "john.doe@gmail.com",
    onChange: e => {
      handleChange(e);
      setOrganisation([]);
      setFieldValue('organisation_id', '');
    },
    onBlur: handleBlur,
    value: values.email
  })), /*#__PURE__*/React.createElement(Box, {
    flex: true,
    justify: "end",
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, "Or")), /*#__PURE__*/React.createElement(FormField, {
    name: "phone",
    label: 'Phone number',
    error: touched.phone && errors.phone && errors.phone.number
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    inputProps: {
      name: 'phone'
    },
    onChange: phone => {
      setFieldValue('phone', {
        ...phone
      });
      setOrganisation([]);
      setFieldValue('organisation_id', '');
    },
    onBlur: handleBlur,
    value: values.phone
  }))) : primaryContact === 'PHONE' && allowAltRecovery === 'false' ? /*#__PURE__*/React.createElement(FormField, {
    name: "phone",
    label: 'Phone number',
    error: touched.phone && errors.phone && errors.phone.number
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    inputProps: {
      name: 'phone'
    },
    onChange: phone => {
      setFieldValue('phone', {
        ...phone
      });
      setOrganisation([]);
      setFieldValue('organisation_id', '');
    },
    onBlur: handleBlur,
    value: values.phone
  })) : null, organisation?.length > 0 && /*#__PURE__*/React.createElement(FormField, {
    name: "organisation_id",
    label: "Select an Organization",
    error: touched.organisation_id && errors.organisation_id
  }, /*#__PURE__*/React.createElement(Select, {
    name: "organisation_id",
    options: organisation,
    labelKey: "name",
    value: values.organisation_id,
    valueKey: {
      key: 'pk',
      reduce: true
    },
    onChange: ({
      value
    }) => {
      setFieldValue('organisation_id', value);
    }
  })), /*#__PURE__*/React.createElement(Box, {
    fill: "horizontal",
    direction: "row-responsive",
    elevation: "none",
    justify: "between",
    align: "center",
    pad: "none"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "start",
    margin: {
      top: 'small'
    },
    label: isSubmitting ? 'Sending Link...' : 'Send',
    disabled: isSubmitting,
    primary: true,
    color: "secondary"
  }), /*#__PURE__*/React.createElement(Link, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(Anchor, {
    as: "span",
    label: "Log in to existing account",
    size: "small",
    margin: {
      vertical: 'small'
    },
    color: "secondary"
  }))), /*#__PURE__*/React.createElement(Text, {
    as: "div",
    color: "status-critical"
  }, errors.non_field)));
};
export default RequestTokenForm;